import styled                        from 'styled-components';

import { DialogVariants            } from 'src/components/common/dialog';
import { ButtonVariants            } from 'src/components/common/button';

import { RevokeTokenDialogVariants } from 'src/components/features/main/token/revoke-token-dialog';

import { cssFlexColumn, 
         cssFlexRow, 
         themeColors, 
         themeTypos,
         Typo,
         typoAsCSS                 } from 'src/providers/theme/shared';



type TokenItemLookAndFeel = {
  paddings: number[];

  gap: number;

  backgroundColor: string;

  expireTypo: Typo;
  expireColor: string;

  tokenTypo: Typo;
  tokenColor: string;

  textGap: number;
  buttonsGap: number;

  buttonSize: number;
  buttonBorderColor: string;
  buttonIconColor: string;

  dialogVariant: DialogVariants;
  revokeVariant: RevokeTokenDialogVariants;
  copyButtonVariant: ButtonVariants;
  revokeButtonVariant: ButtonVariants;
}

const tokenitem_light: TokenItemLookAndFeel = {
  paddings: [14, 12, 14, 15],

  gap: 8,

  backgroundColor: themeColors.SurfaceBackgroundSecondary,

  expireTypo: themeTypos.GRTSKREG_W400_S14_LH18,
  expireColor: themeColors.TextNeutralText100,

  tokenTypo: themeTypos.GRTSKREG_W400_S14_LH18,
  tokenColor: themeColors.TextNeutralText50,

  textGap: 4,
  buttonsGap: 8,

  buttonSize: 40,
  buttonBorderColor: themeColors.CardBorderColor,
  buttonIconColor: themeColors.AccentBlue2,

  dialogVariant: 'lightround',
  revokeVariant: 'light',
  copyButtonVariant: 'primary',
  revokeButtonVariant: 'text',
}

export type TokenItemVariants = 'light';

export const tokenitem_variants: Map<TokenItemVariants, TokenItemLookAndFeel> = 
  new Map<TokenItemVariants, TokenItemLookAndFeel>([
    ['light', tokenitem_light],
  ]);

export const Container = styled.div<{
  lookAndFeel: TokenItemLookAndFeel;
}>`
  ${cssFlexColumn};
  gap: ${(args) => args.lookAndFeel.gap}px;
  width: 100%;

  background-color: ${(args) => args.lookAndFeel.backgroundColor};

  padding-top: ${(args) => args.lookAndFeel.paddings[0]}px;
  padding-right: ${(args) => args.lookAndFeel.paddings[1]}px;
  padding-bottom: ${(args) => args.lookAndFeel.paddings[2]}px;
  padding-left: ${(args) => args.lookAndFeel.paddings[3]}px;
`

export const ContentContainer = styled.div<{
  lookAndFeel: TokenItemLookAndFeel;
}>`
  ${cssFlexColumn};
  gap: ${(args) => args.lookAndFeel.textGap}px;
`

export const ExpireText = styled.div<{
  lookAndFeel: TokenItemLookAndFeel;
}>`
  ${(args) => typoAsCSS(args.lookAndFeel.expireTypo)};
  color: ${(args) => args.lookAndFeel.expireColor };
`

export const TokenText = styled.div<{
  lookAndFeel: TokenItemLookAndFeel;
}>`
  ${(args) => typoAsCSS(args.lookAndFeel.tokenTypo)};
  color: ${(args) => args.lookAndFeel.tokenColor };
  text-overflow: ellipsis;
  overflow: hidden;
`

export const ActionsContainer = styled.div<{
  lookAndFeel: TokenItemLookAndFeel;
}>`
  ${cssFlexRow};
  align-self: flex-end;
  gap: ${(args) => args.lookAndFeel.buttonsGap}px;
  flex-shrink: 0;

  & > * {
    border-radius: 999px;
  }
  
  & > *:first-child > * {
    color: ${ themeColors.AccentRed1 } !important;
  }
`
